import { BaseErrorUtility } from "../core/baseUtility";
import type { MappedHttpRequest, SendErrorResponse } from "../core/types";
import type { HonoRequest } from "hono";
import { URL } from "node:url";

/**
 * Implements request mapping for Hono.
 * See `sendErrorFromEndPoint` method.
 */
export class HonoErrorUtility extends BaseErrorUtility<HonoRequest> {
	protected async mapRequest<TRequest extends HonoRequest = HonoRequest>(
		req: TRequest,
	): Promise<MappedHttpRequest> {
		const parsedUrl = new URL(req.url);

		const [url] = parsedUrl.pathname.split("?");

		let requestBody: unknown;
		try {
			// TODO: It will lose requestBody if server expects text instead of json
			requestBody = await req.json();
		} catch (e) {
			requestBody = null;
		}

		const query = req.query();

		const result = {
			method: req.method.toUpperCase(),
			url,
			requestBody,
			headers: req.header(),
			query: Object.keys(query).length ? query : null,
		};

		return result;
	}

	/**
	 * Sends error and Hono request details to try-catch-cloud service.
	 * ```
	 * app.onError(async (err, ctx) => {
	 *     errorUtility.sendErrorFromEndPoint(err, ctx.req, { ...errorContext })
	 *         .catch((e) => { ... });
	 *
	 *     return ctx.json({ message: 'Internal server error' }, 500);
	 * });
	 * ```
	 */
	async sendErrorFromEndPoint(
		error: unknown,
		request: HonoRequest,
		userContext?: Record<string, unknown> | undefined,
	): Promise<SendErrorResponse> {
		return super.sendErrorFromEndPoint(error, request, userContext);
	};
}
